/** Updated by useMessagingInbox so we can skip notification sound when user is already in that thread. */
export const messagingFocusRef = {
  messagingTabActive: false,
  currentConversationId: null
};
